import {atom} from "nanostores";

export type SectionName =
    | "screensaver"
    | "intro_text"
    | "intro_universe"
    | "briefing"
    | "editor"
    | "end"
    | "share";

export interface NavigationState {
    isTransitioning: boolean;
    currentSection: SectionName;
}

export const navigationState = atom<NavigationState>({
    isTransitioning: false,
    currentSection: "screensaver",
});

export const setTransitioning = (transitioning: boolean) => {
    navigationState.set({
        ...navigationState.get(),
        isTransitioning: transitioning,
    });
};

export const setCurrentSection = (section: SectionName) => {
    navigationState.set({
        ...navigationState.get(),
        currentSection: section,
    });
};

export const startSectionTransition = (targetSection: SectionName) => {
    navigationState.set({
        isTransitioning: true,
        currentSection: targetSection,
    });
};

export const endSectionTransition = () => {
    navigationState.set({
        ...navigationState.get(),
        isTransitioning: false,
    });
};
